/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Tier__Trial5Inputs */

const en_subscription_tier__trial5 = /** @type {(inputs: Subscription_Tier__Trial5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`💎 Premium (Trial)`)
};

/**
* | output |
* | --- |
* | "💎 Premium (Trial)" |
*
* @param {Subscription_Tier__Trial5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const subscription_tier__trial5 = /** @type {((inputs?: Subscription_Tier__Trial5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Tier__Trial5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_subscription_tier__trial5(inputs)
});
export { subscription_tier__trial5 as "subscription_tier__TRIAL" }